import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import TripDelayService from "services/SettingTripDelayService";

export const getTripDelayApi = createAsyncThunk(
  "setting/trip-delay/getTripDelayApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await TripDelayService.getTripDelayConfigApi();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const updateTripDelayApi = createAsyncThunk(
  "setting/trip-delay/updateTripDelayApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await TripDelayService.updateTripDelayApi(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

const initialState = {
  loading: false,
  config: {},
};
export const settingTripDelaySlice = createSlice({
  name: "setting-trip-delay",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTripDelayApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTripDelayApi.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(getTripDelayApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTripDelayApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTripDelayApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTripDelayApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = settingTripDelaySlice.actions;

export default settingTripDelaySlice.reducer;
